import { CrumbItem } from "@/lib/constants"
import Link from "next/link";


const BreadCrumbItem = (props: CrumbItem) => {
  const { name, url, custom_link, link } = props;

  return (
    <>
      {link && url !== null && url !== undefined && url.length > 0 ? (
        <Link href={custom_link !== null ? custom_link : url}>
          <p className="text-xs text-black capitalize hover:text-mooimom" dangerouslySetInnerHTML={{__html: name}}></p>
        </Link>
      ) : (
        <div className="text-xs font-bold capitalize text-mooimom" dangerouslySetInnerHTML={{__html: name}}></div>
      )}
    </>
  )
}

export default BreadCrumbItem
